export default __webpack_public_path__ + "static/media/480_private01-es-web.1761e2fd.png";